import React, { useState } from "react";
import "./MobileIndex.css";
import CapriFooter from "./../../assets/capri-logo-footer.webp";

function Footer() {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <footer className="footer-mob">
      <div className="footer-container-mob">
        {/* Company Section */}
        <div className="footer-column-mob">
          <h4 onClick={() => toggleSection("company")}>
            Company <span>{activeSection === "company" ? "-" : "+"}</span>
          </h4>
          <ul
            className={activeSection === "company" ? "open-mob" : "closed-mob"}
          >
            <li>
              <a className="nav-text" href="/about-us">About Us</a>
            </li>
            <li>
              <a className="nav-text" href="/">Our Strategy</a>
            </li>
            <li>
              <a className="nav-text" href="/teams">Teams</a>
            </li>
            <li>
              <a className="nav-text" href="/portfolio">Our Portfolio</a>
            </li>
          </ul>
        </div>

        {/* Learn Section */}
        <div className="footer-column-mob">
          <h4 onClick={() => toggleSection("learn")}>
            Learn <span>{activeSection === "learn" ? "-" : "+"}</span>
          </h4>
          <ul className={activeSection === "learn" ? "open-mob" : "closed-mob"}>
            <li>
              <a className="nav-text" href="/news-media">News and Media</a>
            </li>
          </ul>
        </div>

        {/* Support Section */}
        <div className="footer-column-mob">
          <h4 onClick={() => toggleSection("support")}>
            Support <span>{activeSection === "support" ? "-" : "+"}</span>
          </h4>
          <ul
            className={activeSection === "support" ? "open-mob" : "closed-mob"}
          >
            <li>
              <a className="nav-text" href="/contact">Get in Touch</a>
            </li>
            <li>
              <a className="nav-text" href="#terms">Terms and Conditions</a>
            </li>
            <li>
              <a className="nav-text" href="#privacy">Privacy Policy</a>
            </li>
            <li>
              <a className="nav-text" href="#sitemap">Sitemap</a>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-column-mob">
          <h4 onClick={() => toggleSection("contact")}>
            Contact <span>{activeSection === "contact" ? "-" : "+"}</span>
          </h4>
          <ul
            className={activeSection === "contact" ? "open-mob" : "closed-mob"}
          >
            <li>
              <a className="nav-text" href="tel:+91224088100">📞 +91-22-40888100</a>
            </li>
            <li>
              <a  className="nav-text" href="mailto:support@caprixponentia.in">
                📧 support@caprixponentia.in
              </a>
            </li>
            <li>
              <p>
                📍 1B, 1st Floor, Court Chambers,
                <br />
                35, Sir Vithaldas Thackersey Marg,
                <br />
                New Marine Lines, Mumbai - 400020.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom-mob">
        <div className="footer-logo-mob">
          <img src={CapriFooter} alt="Capri Xponentia Managers LLP Logo" />
        </div>
        <div className="footer-links-mob">
          <a href="#fraud-alert">Fraud Alert</a> |{" "}
          <a href="#sitemap">Sitemap</a>
        </div>
        <p>&copy; 2024 All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
